// extracted by mini-css-extract-plugin
module.exports = {"BundlesAccordianWrapper":"BundlesAccordian_BundlesAccordianWrapper__07Hsr"};